export const formatDateUTC = (dateString: string, includeYear: boolean = false, includeTime: boolean = false) => {
  const date = new Date(dateString)
  const day = date.getUTCDate().toString().padStart(2)
  const month = date.getUTCMonth()
  const weekDayNames = ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag']
  const weekDayName = weekDayNames[date.getUTCDay()]
  const monthNames = ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december']

  const monthName = monthNames[month]
  const year = date.getUTCFullYear()
  const timeString = includeTime ? ` kl. ${date.getUTCHours().toString().padStart(2, '0')}:${date.getUTCMinutes().toString().padStart(2, '0')}` : ''

  return includeYear ? `${day}. ${monthName} ${year}${timeString}` : `${weekDayName} ${day}. ${monthName}${timeString}`
}

export const formatTimeUTC = (dateString: string) => {
  const date = new Date(dateString)
  const hours = date.getUTCHours().toString().padStart(2, '0')
  const minutes = date.getUTCMinutes().toString().padStart(2, '0')
  return `${hours}:${minutes}`
}

export const formatMultipleDateUTC = (startDateString: string, endDateString: string) => {
  const weekDayNames = ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag']
  const startDate = new Date(startDateString)
  const startDay = startDate.getUTCDate().toString()
  const endDate = new Date(endDateString)
  const endDay = endDate.getUTCDate().toString()
  const startWeekDay = weekDayNames[startDate.getUTCDay()]
  const endWeekDay = weekDayNames[endDate.getUTCDay()]
  const monthNames = ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december']
  const startMonth = monthNames[startDate.getUTCMonth()]
  const endMonth = monthNames[endDate.getUTCMonth()]

  return ` ${startWeekDay} ${startDay}. ${startMonth} - ${endWeekDay} ${endDay}. ${endMonth}`
}

export const formatSingleHHMM = (dateString: string) => {
  const date = new Date(dateString)
  const hours = date.getUTCHours().toString().padStart(2, '0')
  const minutes = date.getUTCMinutes().toString().padStart(2, '0')
  return `${hours}:${minutes}`
}

export const formatDateWithTodayCheck = (dateString: string) => {
  const date = new Date(dateString)
  const today = new Date()
  if (date.toDateString() === today.toDateString()) {
    return 'I dag'
  } else {
    return formatDateUTC(dateString, true)
  }
}

export const formatDateBackend = (dateString: string, includeYear: boolean = true, includeTime: boolean = false) => {
  if (!dateString) {
    console.error('Invalid date string:', dateString)
    return 'Ugyldig dato'
  }

  const date = new Date(dateString)
  if (isNaN(date.getTime())) {
    console.error('Failed to parse date:', dateString)
    return 'Ugyldig dato'
  }

  const day = date.getDate().toString().padStart(2, '0')
  const month = date.getMonth()
  const weekDayNames = ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag']
  const weekDayName = weekDayNames[date.getDay()]
  const monthNames = ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december']

  const monthName = monthNames[month]
  const year = date.getFullYear()
  const timeString = includeTime ? ` kl. ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}` : ''

  return `${weekDayName} ${day}. ${monthName}${includeYear ? ` ${year}` : ''}${timeString}`
}
